module.exports = __webpack_public_path__ + "static/img/color1-1.73721f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/color1-1.png
// module id = ctAH
// module chunks = 1